import React, { useState, useEffect } from "react";
import "./board.css";
import Profiles from "./Profiles";
import { SpinStretch } from "react-cssfx-loading";

const Leaderboard = () => {
  // console.log("in leaderboard");
  const [allusers, setallusers] = useState([]);
  const [mode, setmode] = useState(1);
  const [onlyFriends, setonlyFriends] = useState(0);

  //mode 0 means today data and 1 means all data
  const fetchUserData = async () => {
    // console.log("getting leader data");
    const oldDate = new Date();
    var curdate = oldDate.toDateString();

    let response = await fetch(
      //   "http://localhost:5000/api/leaderboard",
      "https://animedoro-backend.vercel.app/api/leaderboard",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          curDate: curdate,
        }),
      },
    );
    const json = await response.json();
    if (response.status === 200) {
      setallusers(json["allUsers"].sort(comparebytotal));
    }
  };
  function convertdata(data) {
    return data.sort();
  }
  function handleClick(cmod) {
    // console.log(cmod);
    if (cmod !== mode) {
      setmode(cmod);
      if (cmod === 0) {
        setallusers(allusers.sort(comparebytoday));
      } else {
        setallusers(allusers.sort(comparebytotal));
      }
    }
  }
  // console.log(allusers);
  function comparebytoday(a, b) {
    if (a.todayminutes > b.todayminutes) return -1;
    if (a.todayminutes > b.todayminutes) return 1;
    return 0;
  }
  function comparebytotal(a, b) {
    if (a.totalminutes > b.totalminutes) return -1;
    if (a.totalminutes < b.totalminutes) return 1;
    return 0;
  }
  useEffect(() => {
    fetchUserData();
  }, []);
  return (
    <div
      className="py-12"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div className="board">
        <h1
          className="leaderboard !font-light"
          style={{ textAlign: "center", alignItems: "center" }}
        >
          Leaderboard
        </h1>
        <div className="lb-controls">
          <div className="lb-segment">
            <button
              onClick={() => {
                handleClick(0);
              }}
              className={`${mode === 0 ? "clicked" : ""}`}
            >
              Today
            </button>
            {/* 0 means for current date and 1 means for all the dates */}
            <button
              onClick={() => {
                handleClick(1);
              }}
              className={`${mode === 1 ? "clicked" : ""}`}
            >
              All Time
            </button>
          </div>
          <div className="lb-segment">
            <button
              onClick={() => {
                setonlyFriends(0);
              }}
              className={`${onlyFriends === 0 ? "clicked" : ""}`}
            >
              All
            </button>
            <button
              onClick={() => {
                setonlyFriends(1);
              }}
              className={`${onlyFriends === 1 ? "clicked" : ""}`}
            >
              Friends
            </button>
          </div>
        </div>
        {allusers.length !== 0 ? (
          <Profiles
            boarddata={allusers}
            mode={mode}
            onlyFriends={onlyFriends}
          ></Profiles>
        ) : (
          <div className="my-5" style={{ marginLeft: "48%" }}>
            <SpinStretch color="#F5E8C7" />
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Leaderboard);
